import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, PrinterIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const trustItems = [[DownloadIcon, 'Instant digital download'], [ShieldCheckIcon, '30-day money-back guarantee'], [PrinterIcon, 'Print and digital ready']] as const;
export function HeroSection() {
  return <section className="flex min-h-[calc(100svh-2.25rem)] items-center bg-tr-cream px-5 py-6 md:py-10" data-id="element-103" data-mp="2wjp9tfzgmtzg">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex w-full max-w-container flex-col items-center justify-center text-center" data-id="element-104" data-mp="30las5gurk0h1">
        <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-tr-grey/70 sm:text-[11px]" data-id="element-105" data-mp="2rqw3wos99fls">
          The Complete Tennis Curriculum
        </p>
        <h1 className="mt-3 max-w-4xl text-[1.85rem] font-bold leading-[1.08] tracking-tight text-tr-navy sm:text-[2.6rem] md:text-[3.2rem]" data-id="element-106" data-mp="3kactszmnha2d">
          Teach a Full Season of{' '}
          <span className="font-accent italic text-tr-green" data-id="element-107" data-mp="2beq14vx4ourn">Tennis</span>
          <br className="hidden sm:block" data-id="element-108" data-mp="2p5bniulsjmua" /> in Just 5 Minutes of Prep
        </h1>
        <p className="mt-3 max-w-[42ch] text-[13.5px] leading-relaxed text-tr-grey sm:text-[15px] md:max-w-[54ch] md:text-base" data-id="element-109" data-mp="2p7ejdv9mka6x">
          Tennis Ready is a complete, done-for-you teaching system — six
          progressive volumes packed with drills, lesson plans, physical work and
          assessments, from first contact to competition.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/xpD7tfwryfAT9qwCRjt6u2/ChatGPT_Image_25_ago_2026,_13_51_30-Photoroom.png" alt="The Tennis Ready product family: six spiral-bound volumes, monitor and tablet with digital files, rackets, balls, cones and five bonus booklets" className="my-4 max-h-[38svh] w-auto max-w-full object-contain drop-shadow-[0_20px_36px_rgba(23,38,79,0.16)] md:my-5 md:max-h-[42svh]" data-id="element-110" data-mp="3834ovsgrnopk" />
        <CTAButton className="w-full max-w-sm sm:w-auto" data-id="element-111" data-mp="38vnwkgt0h36u" />
        <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[11px] font-medium text-tr-grey sm:text-[12.5px]" data-id="element-112" data-mp="3dt7gnxce4a6p">
          {trustItems.map(([Icon, label], index) => <li key={label} className="flex items-center gap-3" data-id="element-113" data-mp="3munpi0nk448t" data-mpi={index}>
              {index > 0 && <span className="text-tr-grey/40" aria-hidden="true" data-id="element-114" data-mp="3rrnvkbkep6zx">
                  ·
                </span>}
              <span className="flex items-center gap-1.5" data-id="element-115" data-mp="jjfocumqfpi">
                <Icon className="h-3.5 w-3.5 text-tr-green" aria-hidden="true" data-id="element-116" data-mp="5dxeyqcex6zg" />
                {label}
              </span>
            </li>)}
        </ul>
      </motion.div>
    </section>;
}